<!-- 历史累计收益 -->
<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <p class="title">历史累计收益</p>

    <div class="top">
      <div class="t_left">
        <p>
          <span class="icon"></span>
          {{ holdPeriod + '天' }}
        </p>

        <p>
          <span class="icon"></span>
          沪深300
        </p>
      </div>

      <!-- <p class="t_right" @click="showTimeSheet = true">
        {{ time }}
        <van-icon name="arrow-down" class="arrow-down" />
      </p> -->
    </div>

    <van-action-sheet v-model="showTimeSheet">
      <van-picker
        title="选择时间"
        show-toolbar
        :columns="columnsTimeSheet"
        @confirm="onConfirmTimeSheet"
        @cancel="onCancelTimeSheet"
      />
    </van-action-sheet>

    <div id="lineDom" style="height: 200px" v-show="BaseSnapShotListX.length"></div>

    <div class="lineDomX">
      <p>{{ BaseSnapShotListX[0] }}</p>
      <p>{{ BaseSnapShotListX[BaseSnapShotListX.length - 1] }}</p>
    </div>

    <van-empty
      description="暂无数据"
      v-show="!BaseSnapShotListX.length"
      :image="require('@/assets/image/notData.png')"
    />
  </div>
</template>

<script>
import { backtestTradeQueryDetail } from '@/api/create';
import { judgeColor, toFixedNum, formatStrTime, dateFormat } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Ljsy',
  mixins: [mixin],
  props: ['Obj', 'checkedYzList', 'headerHeight', 'tabsHeight'],
  data() {
    return {
      zxxgThHeight: 0,
      hqList: [],
      time: '近一周',
      columnsTimeSheet: ['近一周', '近一月', '近一年', '全部'],
      showTimeSheet: false,
      lineDom: null,
      BaseSnapShotListX: [], //沪深300
      BaseSnapShotListY: [], //沪深300
      PosSnapShotListY: [], //最优天数
      holdPeriod: 2 //最优数据的天
    };
  },
  filters: {},
  created() {},
  watch: {},
  async mounted() {
    // 获取maxYearRate最大值的对象
    var maxYearRateObj = this.Obj.apiData.BacktestAnalysisResult.reduce(function (prev, current) {
      return prev.YearRate > current.YearRate ? prev : current;
    });

    // 获取HoldPeriod的值
    this.holdPeriod = maxYearRateObj.HoldPeriod;

    await this.backtestTradeQueryDetailFun();
    this.lintFun();
  },
  methods: {
    judgeColor,
    toFixedNum,
    formatStrTime,
    dateFormat,
    //select
    onConfirmTimeSheet: function (value, index) {
      this.showTimeSheet = false;
      this.time = value;
    },
    onCancelTimeSheet: function (picker, value, index) {
      this.showTimeSheet = false;
    },

    //获取折线图数据

    backtestTradeQueryDetailFun: function () {
      var idArray = this.checkedYzList.map((obj) => obj.ID);

      var params = {
        userID: this.Obj.apiData.uname || this.Obj.apiData.condition.author, //用户id
        hashID: this.Obj.apiData.HashID, //回测ID (云平台)  由回测策略生成的唯一值 eg:3342389003495
        factorlist: idArray.toString(), //因子id - id,id
        startDate: this.Obj.startDate,
        endDate: this.Obj.endDate,
        holdPeriod: this.holdPeriod, //持股周期只允许填入单周期, 单位:天 eg:2
        detailType: 2, //0:交易记录明细+每日持仓快照明细1:交易记录明细 2:每日持仓快照明细(折线图)
        baseData: 0, //0:返回基准指标数据 1:不返回基准指标数据
        start: 0, //开始位置 历史明细专用
        count: 10000 //单次获取数据量历史明细专用
      };
      return backtestTradeQueryDetail(params)
        .then((res) => {
          if (res.err === 200) {
            this.BaseSnapShotListX = res.data.BaseSnapShotList.map((item) =>
              dateFormat('YYYY-MM-DD', item.Tradday)
            ); //沪深300X轴
            this.BaseSnapShotListY = res.data.BaseSnapShotList.map((item) =>
              (item.ProfitRate * 100).toFixed(2)
            ); //沪深300Y轴
            this.PosSnapShotListY = res.data.PosSnapShotList.map((item) =>
              (item.ProfitRate * 100).toFixed(2)
            ); //最优Y轴
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    //折线图
    lintFun: function () {
      var _this = this;
      _this.lineDom = _this.$echarts.init(document.getElementById('lineDom'));
      window.addEventListener('resize', _this.resizeline);

      var option = {
        grid: {
          left: 0,
          top: 20,
          right: 0,
          bottom: 0,
          containLabel: true
        },

        tooltip: {
          extraCssText: 'z-index:2', // 设置 tooltip 的层级为 999
          trigger: 'axis',
          backgroundColor: _this.$route.query.themeStyleVs == 2 ? '#181A23' : '#fff',
          borderColor: _this.$route.query.themeStyleVs == 2 ? '#181A23' : '#fff', // 设置 Tooltip 的边框颜色
          textStyle: {
            // 设置 Tooltip 中文字的样式
            color: _this.$route.query.themeStyleVs == 2 ? '#AAB9D1' : '' // 设置文字颜色
          },
          formatter: function (params) {
            var tooltip = params[0].name + '<br>'; // 获取 x 轴坐标
            params.forEach(function (item) {
              var seriesName = item.seriesName; // 获取系列名称
              var dataValue = item.value + '%'; // 获取数据项的数值并添加百分比符号

              // 使用自定义HTML添加圆点
              var dot =
                '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:6px;height:6px;background-color:' +
                item.color +
                '"></span>';
              tooltip += dot + seriesName + '<br>' + ' 收益率: ' + dataValue + '<br>'; // 拼接每个数据项的字符串
            });
            return tooltip;
          }
        },

        xAxis: {
          type: 'category',
          data: _this.BaseSnapShotListX,
          show: false,
          axisLabel: {
            color: '#999', // 设置横坐标值的颜色为红色
            fontSize: 12 // 设置横坐标值的字体大小为12px
          },
          axisTick: {
            show: false // 隐藏 X 轴刻度线
          },
          axisLine: {
            lineStyle: {
              color: '#F5F6F9' // 设置 X 轴颜色
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#999', // 设置横坐标值的颜色为红色
            fontSize: 12, // 设置横坐标值的字体大小为12px
            formatter: '{value}%'
          },
          splitLine: {
            lineStyle: {
              color: _this.$route.query.themeStyleVs == 2 ? '#403941' : '#F5F6F9' // 修改 Y 轴的分割线颜色为红色
            }
          }
        },
        series: [
          {
            name: _this.holdPeriod + '天',
            data: _this.PosSnapShotListY,
            type: 'line',
            showSymbol: false, // 设置为 false 隐藏小圆点
            lineStyle: {
              color: '#296DF7', // 设置折线颜色为蓝色
              width: 1.5 // 设置折线的粗细为2
            },
            itemStyle: {
              color: '#296DF7' // 圆点颜色与折线颜色一致
            },
            smooth: true, // 开启平滑曲线
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(40,68,247,0.2)' // 渐变起始颜色
                  },
                  {
                    offset: 1,
                    color: _this.$route.query.themeStyleVs == 2 ? '#242129' : '#fff' // 渐变结束颜色
                  }
                ]
              }
            }
          },
          {
            name: '沪深300',
            data: _this.BaseSnapShotListY,
            type: 'line',
            showSymbol: false, // 设置为 false 隐藏小圆点
            lineStyle: {
              color: '#E78D64', // 设置折线颜色为蓝色
              width: 1.5 // 设置折线的粗细为2
            },
            itemStyle: {
              color: '#E78D64'
            },
            smooth: true, // 开启平滑曲线
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(255,136,9,0.2)' // 渐变起始颜色
                  },
                  {
                    offset: 1,
                    color: _this.$route.query.themeStyleVs == 2 ? '#242129' : '#fff' // 渐变结束颜色
                  }
                ]
              }
            }
          }
        ]
      };
      _this.lineDom.setOption(option);

      window.addEventListener('resize', function () {
        _this.lineDom.resize(); //自适应
      });
    },

    getStockHqFun: function () {
      var stockCodes = []; // 用于存储 StockCode 的数组

      this.StockPoolsResult.List.forEach(function (item) {
        stockCodes.push(item.StockCode);
      });
      var params = {
        stockID: stockCodes.toString()
      };
      getStockHq(params)
        .then((res) => {
          if (res.err === 200) {
            this.hqList = res.data;
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.index-info {
  padding: 15px;
  .title {
    color: rgba(0, 0, 0, 0.9);
    font-size: 16px;
    font-weight: 600;
  }
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .t_left {
      display: flex;
      align-items: center;
      p {
        display: flex;
        align-items: center;
        color: #555;
        font-size: 14px;
        .icon {
          width: 16px;
          height: 4px;
          margin-right: 6px;
        }

        &:first-child {
          .icon {
            background: rgba(40, 109, 247, 0.2);
            border-top: 2px solid #286df7;
          }
        }
        &:last-child {
          .icon {
            background: rgba(247, 152, 40, 0.2);
            border-top: 2px solid #ff9153;
            margin-left: 16px;
          }
        }
      }
    }
    .t_right {
      display: flex;
      align-items: center;
      padding: 2px 6px;
      border-radius: 6px;
      background: #f5f6f9;
      color: #333;
      font-size: 12px;
    }
  }
  .lineDomX {
    display: flex;
    justify-items: center;
    justify-content: space-between;
    color: #999;
    font-size: 12px;
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title {
    color: #e4e9fe;
  }
  .top {
    .t_left {
      p {
        color: #e4e9fe;
      }
    }
  }
}
</style>
